export const QUOTATION_SERVICE_PAGE_SIZE = 10;

export const normalizeCategory = (category = {}) => {
  const id = category.id || category._id;

  return {
    id,
    name: category.name || category.categoryName || "Chưa cập nhật",
    description: category.description || "",
    image: category.image || "",
  };
};

export const normalizeCategoriesResponse = (response) => {
  const categories =
    response?.categories ||
    response?.data?.categories ||
    response?.data ||
    [];

  return (Array.isArray(categories) ? categories : [])
    .map(normalizeCategory)
    .filter((category) => Boolean(category.id));
};

export const normalizeService = (service = {}, selectedCategory) => ({
  id: service._id || service.id,
  name: service.serviceName || service.name || "Chưa cập nhật",
  basePrice: parseInt(service.price, 10) || 0,
  licenseFee: parseInt(service.licenseFee || service.certificateFee || service.issueFee, 10) || 0,
  unit: "dịch vụ",
  code: service.serviceCode || service.code || "Chưa cập nhật",
  category:
    service.category?.categoryName ||
    service.categoryId?.categoryName ||
    service.categoryName ||
    selectedCategory?.name ||
    "Chưa cập nhật",
  priceTiers: Array.isArray(service.priceTiers) ? service.priceTiers : [],
  additionalFee: parseInt(service.additionalFee, 10) || 0,
});

export const normalizeServicesResponse = (response, selectedCategory) => {
  const services =
    response?.services ||
    response?.data?.services ||
    response?.data ||
    [];

  return (Array.isArray(services) ? services : [])
    .map((service) => normalizeService(service, selectedCategory))
    .filter((service) => Boolean(service.id));
};

export const getHasMoreServices = (response, receivedCount) => {
  const pagination = response?.pagination || response?.data?.pagination;

  if (pagination) {
    const currentPage = Number(pagination.currentPage || pagination.page || 1);
    const totalPages = Number(pagination.totalPages || 1);
    return currentPage < totalPages;
  }

  const currentPage = Number(response?.currentPage || response?.data?.currentPage || 1);
  const totalPages = Number(response?.totalPages || response?.data?.totalPages || 1);

  if (totalPages > 1) {
    return currentPage < totalPages;
  }

  return receivedCount === QUOTATION_SERVICE_PAGE_SIZE;
};
